export default __webpack_public_path__ + "static/media/landing_page_hex_4.bafacbc3.png";